import {Image} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/image.types';
import {SpotlightSection_Element} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {PromotionTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/tracker.types';

export type CardType = {
  duration: {seconds: number};
  headline: string;
  href: string;
  image: Image;
  promotionTracker: PromotionTracker;
  topline: string;
};

export const normalizeSpotlightCards = (
  elements: SpotlightSection_Element[],
) => {
  return elements.reduce((cards, element) => {
    if (element.type?.$case === 'teaser') {
      const teaser = element.type.teaser;

      cards.push({
        duration: {seconds: 5},
        headline: teaser.headline,
        href: teaser.linkTarget.url,
        image: teaser.coverSquareImage,
        promotionTracker: teaser.promotionTracker,
        topline: teaser.topline,
      });
    }

    return cards;
  }, [] as CardType[]);
};
